<template>
  <div :style="themeStyle" height="100%">
    <v-row class="headline1_bg p-3"  no-gutters>
      <v-col cols="12">
        {{ $t("message.promotion") }}
      </v-col>
    </v-row>
    <v-container class="pt-5" v-if="item" height="100%">
      <v-card
        class="mx-auto rounded-lg"
        elevation="2"
        height="100%"
      >
        <v-img class="white--text align-end" :src="item.promotionPicture"
        >
        </v-img>
        <v-container fluid>
          <v-row v-if="$i18n.locale === 'th' || item.promotionNameEng === '' || item.promotionNameEng === null">
              <v-col class="headline1 bold font18">{{item.promotionName}}</v-col>
          </v-row>
          <v-row v-if="$i18n.locale === 'en' && item.promotionNameEng !== null && item.promotionNameEng !== ''">
              <v-col class="headline1 bold font18">{{item.promotionNameEng}}</v-col>
          </v-row>
          <!-- <v-row v-if="item.promotionSubName">
              <v-col class="headline1 bold font14 pt-0"><nl2br tag="p" :text="item.promotionSubName" /></v-col>
          </v-row> -->
          <v-row v-if="$i18n.locale === 'th' || item.promotionDetailsEng === '' || item.promotionDetailsEng === null">
            <v-col class="icon2 font14" v-html="makeLinksClickable(item.promotionDetails)"></v-col>
          </v-row>
          <v-row v-if="$i18n.locale === 'en' && item.promotionDetailsEng !== null && item.promotionDetailsEng !== ''">
              <v-col class="icon2 font14" v-html="makeLinksClickable(item.promotionDetailsEng)"></v-col>
          </v-row>
        </v-container>

        <v-card-actions :style="'background-color:' + this.$bgColor">
          <v-btn
            class="rounded-lg"
            text
            block
            dark
            :disabled="canbuy"
            v-if="item.packageId && item.packagePrice !== '0'"
             @click="$router.push(`/BuyPackage/${item.packageId}`)"
          >
          {{ $t("message.buyPackage") }}
          </v-btn>
          <v-btn
            class="rounded-lg"
            text
            block
            dark
            :disabled="canbuy"
            v-if="item.packageId && item.packagePrice === '0'"
            @click="getFreePackage()"
          >
          {{ $t("message.freePackage") }}
          </v-btn>
          <v-btn
            class="rounded-lg"
            text
            block
            dark
            v-if="!item.packageId"
            @click="$router.push('/promotion')"
          >
          {{ $t("message.backToPromotion") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'RewardDetail',
  data () {
    return {
      id: this.$route.params.id,
      item: null,
      member: null,
      profile: null,
      canbuy: false,
      createQRcodePackage: {
        packageId: '',
        status: 'waiting',
        CREATE_USER: '',
        liffId: '',
        LAST_USER: '',
        shopId: '',
        CREATE_DATE: '',
        chkQRCode: 1
      }
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted () {
    this.shopId = await this.GET_SHOPID()
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.checkliff()
    await this.getDetailPromotion()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getDetailPromotion () {
      const result = await this.callBeTaskAPI('get', `/promotion/getID?id=${this.id}`)
      if (result) {
        this.item = result
      }
      if (this.item.limitPackage.toLowerCase() === 'true') {
        const resultPro = await this.callBeTaskAPI('get', `/PackageLog/get?packageId=${this.item.packageId}&memberId=${this.profile.memberId}`)
        if (Array.isArray(resultPro)) {
          for (let i = 0; i < resultPro.length; i++) {
            const currentItem = resultPro[i]
            if (currentItem.status === 'get' || currentItem.status === 'use') {
              this.canbuy = true
              break
            } else if (currentItem.status === 'cancel') {
              this.canbuy = false
            }
          }
          // this.canbuy = true
        } else {
          this.canbuy = false
        }
      }
    },
    makeLinksClickable (text) {
      // eslint-disable-next-line no-useless-escape
      const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
      const linkedText = text.replace(urlPattern, '<a href="$1" target="_blank">$1</a>')
      const textWithBreaks = linkedText.replace(/\n/g, '<br>')
      return textWithBreaks
    },
    async getFreePackage () {
      this.createQRcodePackage.packageId = this.item.packageId
      this.createQRcodePackage.CREATE_USER = this.profile.userId
      this.createQRcodePackage.LAST_USER = this.profile.userId
      this.createQRcodePackage.memberId = this.profile.memberId
      this.createQRcodePackage.liffId = this.$liffId
      this.createQRcodePackage.shopId = this.shopId
      this.createQRcodePackage.masBranchID = ''
      await axios
        .post(this.DNS_IP + '/packageQRcode/add', this.createQRcodePackage)
        .then(async response => {
          // console.log('addDataGlobal DNS_IP + PATH + "add"', response)
          const paramsCollectPackage = {
            'token': response.data.token
          }
          let config = {
            headers: {
              shopId: this.shopId,
              lineId: this.profile.userId,
              memberId: this.profile.memberId
            }
          }
          await axios
            .post(
              this.DNS_IP +
                '/collect_package/edit',
              paramsCollectPackage, config
            )
            .then(response => {
              this.loaded = false
              Swal.fire({
                title: 'รับแพ็กเกจสำเร็จ',
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: 'ตกลง'
              }).then((confirm) => {
                if (confirm.isConfirmed) {
                  if (this.$isTargetShop()) {
                    this.$router.push('/MyPackage')
                  } else {
                    this.$router.push('/C/MyPackage')
                  }
                }
              })
              // console.log('res', res)
              // console.log('assign', this.veiwQRCode)
            })
          // this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          // this.loadingAdd = false
        })
        .catch(error => {
          console.error('error function addDataGlobal : ', error)
          this.$router.push(
            '/system/Errorpage?returnLink=' + this.returnLink
          )
          this.dataReady = true
        })
    },
    async checkliff () {
      const result = await axios.get(this.DNS_Link + `/lineconfig/get?shopId=${this.shopId}`)
      if (Array.isArray(result.data)) {
        // alert('find')
        if (result.data[0].liffMainIDLoyalty !== null) {
          this.$liffId = result.data[0].liffMainIDLoyalty
        } else {
          this.$liffId = '1656906322-JN5MM8Ep'
        }
      } else {
        this.$liffId = '1656906322-JN5MM8Ep'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Promotion/Detail.vue